export default function ErrorMessage({ message }) {
  const msg = message ? message : "Something when wrong. Please try again."
  return (
    <div className="w-100 h-100 position-fixed top-0 right- bottom-0 left-0 bg-white z-3 d-flex flex-column justify-content-center align-items-center" style={{opacity: 0.85}}>
      <div>
        <h2>Oops...</h2>
        <p>{msg}</p>
      </div>
    </div>
  )
}